import React from "react";

const Pincil = () => {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60163 31.8749C12.6114 36.8759 18.8915 38.4119 21.8616 38.7156C23.0424 38.8942 23.7939 38.2691 23.8476 37.3582C23.9191 36.5187 23.4003 35.84 22.3446 35.6257C19.643 35.1792 14.0785 33.8753 9.85602 29.6245C3.00338 22.8017 1.64358 12.2103 7.29746 6.54849C11.8241 2.0476 19.3388 2.49412 24.8853 5.47685L27.2292 3.17283C20.1081 -1.14946 10.6612 -1.29234 5.06096 4.29805C-1.63066 10.9958 -0.843407 23.4447 7.60163 31.8749ZM34.7975 5.95909L36.3183 4.42307C37.1056 3.61934 37.1771 2.4584 36.3899 1.70825L35.8531 1.19029C35.1553 0.547306 34.0281 0.600888 33.2588 1.35104L31.7201 2.88706L34.7975 5.95909ZM17.317 23.3911L33.4735 7.28078L30.3782 4.20875L14.2396 20.3191L12.683 24.0698C12.4861 24.5699 12.9871 25.0522 13.4702 24.8735L17.317 23.3911ZM14.4006 26.4274C20.1081 32.3572 29.9309 34.5719 35.2985 29.2316C39.6641 24.8557 39.2884 17.0863 34.5291 10.3707L32.2389 12.6568C35.7458 17.8186 36.3899 23.6412 33.0441 26.9811C28.9289 31.0891 22.2194 29.2316 17.8359 25.0522L14.4006 26.4274Z"
        fill="#1C1C1E"
      />
    </svg>
  );
};

export default Pincil;
